// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LegalTermsRouteImport } from './routes/legal/terms'
import { Route as LegalPrivacyRouteImport } from './routes/legal/privacy'
import { Route as DriversDriverIdRouteImport } from './routes/drivers/$driverId'
import { Route as AuthSigninRouteImport } from './routes/auth/signin'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AuthAppIndexRouteImport } from './routes/_auth/app/index'
import { Route as AuthAppAdminRouteRouteImport } from './routes/_auth/app/admin/route'
import { Route as AuthAppTelemetryIndexRouteImport } from './routes/_auth/app/telemetry/index'
import { Route as AuthAppSetupsIndexRouteImport } from './routes/_auth/app/setups/index'
import { Route as AuthAppSettingsIndexRouteImport } from './routes/_auth/app/settings/index'
import { Route as AuthAppPackagesIndexRouteImport } from './routes/_auth/app/packages/index'
import { Route as AuthAppDriversIndexRouteImport } from './routes/_auth/app/drivers/index'
import { Route as AuthAppDashboardIndexRouteImport } from './routes/_auth/app/dashboard/index'
import { Route as AuthAppSetupsSetupIdRouteImport } from './routes/_auth/app/setups/$setupId'
import { Route as AuthAppPackagesPackageIdRouteImport } from './routes/_auth/app/packages/$packageId'
import { Route as AuthAppAdminIndexRouteImport } from './routes/_auth/app/admin/index'
import { Route as AuthAppAdminUsersRouteImport } from './routes/_auth/app/admin/users'
import { Route as AuthAppAdminSetupsRouteImport } from './routes/_auth/app/admin/setups'
import { Route as AuthAppAdminScheduleRouteImport } from './routes/_auth/app/admin/schedule'
import { Route as AuthAppAdminPackagesRouteImport } from './routes/_auth/app/admin/packages'
import { Route as AuthAppAdminCarsRouteImport } from './routes/_auth/app/admin/cars'
import { Route as AuthAppAdminAssignmentsRouteImport } from './routes/_auth/app/admin/assignments'
import { Route as AuthAppAdminApprovalsRouteImport } from './routes/_auth/app/admin/approvals'
import { Route as AuthAppDashboardUploadSlotIdRouteImport } from './routes/_auth/app/dashboard/upload.$slotId'

const AuthRouteRoute = AuthRouteRouteImport.update({
            id: '/_auth',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const LegalTermsRoute = LegalTermsRouteImport.update({
            id: '/legal/terms',path: '/legal/terms',getParentRoute: () => rootRouteImport
          })
const LegalPrivacyRoute = LegalPrivacyRouteImport.update({
            id: '/legal/privacy',path: '/legal/privacy',getParentRoute: () => rootRouteImport
          })
const DriversDriverIdRoute = DriversDriverIdRouteImport.update({
            id: '/drivers/$driverId',path: '/drivers/$driverId',getParentRoute: () => rootRouteImport
          })
const AuthSigninRoute = AuthSigninRouteImport.update({
            id: '/auth/signin',path: '/auth/signin',getParentRoute: () => rootRouteImport
          })
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
            id: '/auth/reset-password',path: '/auth/reset-password',getParentRoute: () => rootRouteImport
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const AuthAppIndexRoute = AuthAppIndexRouteImport.update({
            id: '/app/',path: '/app/',getParentRoute: () => AuthRouteRoute
          })
const AuthAppAdminRouteRoute = AuthAppAdminRouteRouteImport.update({
            id: '/app/admin',path: '/app/admin',getParentRoute: () => AuthRouteRoute
          })
const AuthAppTelemetryIndexRoute = AuthAppTelemetryIndexRouteImport.update({
            id: '/app/telemetry/',path: '/app/telemetry/',getParentRoute: () => AuthRouteRoute
          })
const AuthAppSetupsIndexRoute = AuthAppSetupsIndexRouteImport.update({
            id: '/app/setups/',path: '/app/setups/',getParentRoute: () => AuthRouteRoute
          })
const AuthAppSettingsIndexRoute = AuthAppSettingsIndexRouteImport.update({
            id: '/app/settings/',path: '/app/settings/',getParentRoute: () => AuthRouteRoute
          })
const AuthAppPackagesIndexRoute = AuthAppPackagesIndexRouteImport.update({
            id: '/app/packages/',path: '/app/packages/',getParentRoute: () => AuthRouteRoute
          })
const AuthAppDriversIndexRoute = AuthAppDriversIndexRouteImport.update({
            id: '/app/drivers/',path: '/app/drivers/',getParentRoute: () => AuthRouteRoute
          })
const AuthAppDashboardIndexRoute = AuthAppDashboardIndexRouteImport.update({
            id: '/app/dashboard/',path: '/app/dashboard/',getParentRoute: () => AuthRouteRoute
          })
const AuthAppSetupsSetupIdRoute = AuthAppSetupsSetupIdRouteImport.update({
            id: '/app/setups/$setupId',path: '/app/setups/$setupId',getParentRoute: () => AuthRouteRoute
          })
const AuthAppPackagesPackageIdRoute = AuthAppPackagesPackageIdRouteImport.update({
            id: '/app/packages/$packageId',path: '/app/packages/$packageId',getParentRoute: () => AuthRouteRoute
          })
const AuthAppAdminIndexRoute = AuthAppAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthAppAdminRouteRoute
          })
const AuthAppAdminUsersRoute = AuthAppAdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AuthAppAdminRouteRoute
          })
const AuthAppAdminSetupsRoute = AuthAppAdminSetupsRouteImport.update({
            id: '/setups',path: '/setups',getParentRoute: () => AuthAppAdminRouteRoute
          })
const AuthAppAdminScheduleRoute = AuthAppAdminScheduleRouteImport.update({
            id: '/schedule',path: '/schedule',getParentRoute: () => AuthAppAdminRouteRoute
          })
const AuthAppAdminPackagesRoute = AuthAppAdminPackagesRouteImport.update({
            id: '/packages',path: '/packages',getParentRoute: () => AuthAppAdminRouteRoute
          })
const AuthAppAdminCarsRoute = AuthAppAdminCarsRouteImport.update({
            id: '/cars',path: '/cars',getParentRoute: () => AuthAppAdminRouteRoute
          })
const AuthAppAdminAssignmentsRoute = AuthAppAdminAssignmentsRouteImport.update({
            id: '/assignments',path: '/assignments',getParentRoute: () => AuthAppAdminRouteRoute
          })
const AuthAppAdminApprovalsRoute = AuthAppAdminApprovalsRouteImport.update({
            id: '/approvals',path: '/approvals',getParentRoute: () => AuthAppAdminRouteRoute
          })
const AuthAppDashboardUploadSlotIdRoute = AuthAppDashboardUploadSlotIdRouteImport.update({
            id: '/app/dashboard/upload/$slotId',path: '/app/dashboard/upload/$slotId',getParentRoute: () => AuthRouteRoute
          })





const AuthAppAdminRouteRouteChildren = {
  AuthAppAdminApprovalsRoute: AuthAppAdminApprovalsRoute,AuthAppAdminAssignmentsRoute: AuthAppAdminAssignmentsRoute,AuthAppAdminCarsRoute: AuthAppAdminCarsRoute,AuthAppAdminPackagesRoute: AuthAppAdminPackagesRoute,AuthAppAdminScheduleRoute: AuthAppAdminScheduleRoute,AuthAppAdminSetupsRoute: AuthAppAdminSetupsRoute,AuthAppAdminUsersRoute: AuthAppAdminUsersRoute,AuthAppAdminIndexRoute: AuthAppAdminIndexRoute
}

const AuthAppAdminRouteRouteWithChildren = AuthAppAdminRouteRoute._addFileChildren(AuthAppAdminRouteRouteChildren)



const AuthRouteRouteChildren = {
  AuthAppAdminRouteRoute: AuthAppAdminRouteRouteWithChildren,AuthAppIndexRoute: AuthAppIndexRoute,AuthAppPackagesPackageIdRoute: AuthAppPackagesPackageIdRoute,AuthAppSetupsSetupIdRoute: AuthAppSetupsSetupIdRoute,AuthAppDashboardIndexRoute: AuthAppDashboardIndexRoute,AuthAppDriversIndexRoute: AuthAppDriversIndexRoute,AuthAppPackagesIndexRoute: AuthAppPackagesIndexRoute,AuthAppSettingsIndexRoute: AuthAppSettingsIndexRoute,AuthAppSetupsIndexRoute: AuthAppSetupsIndexRoute,AuthAppTelemetryIndexRoute: AuthAppTelemetryIndexRoute,AuthAppDashboardUploadSlotIdRoute: AuthAppDashboardUploadSlotIdRoute
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(AuthRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthRouteRoute: AuthRouteRouteWithChildren,AuthCallbackRoute: AuthCallbackRoute,AuthResetPasswordRoute: AuthResetPasswordRoute,AuthSigninRoute: AuthSigninRoute,DriversDriverIdRoute: DriversDriverIdRoute,LegalPrivacyRoute: LegalPrivacyRoute,LegalTermsRoute: LegalTermsRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)